module.exports = __webpack_public_path__ + "media/images/icons/musical-note-7527b99bc6016fcc7712b8ffca3c087a.svg";